(function () {
  var KEY = 'rv_wishlist';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-rv-heart]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-rv-heart')) > -1;
      if (btn.classList.contains('is-saved') !== on) btn.classList.toggle('is-saved', on);
      if (btn.getAttribute('aria-pressed') !== (on ? 'true' : 'false')) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var text = btn.querySelector('[data-rv-heart-text]');
      var label = on ? 'נשמר ברשימה שלי' : 'שמירה לרשימה שלי';
      if (text && text.textContent !== label) text.textContent = label;
    });
    document.querySelectorAll('[data-rv-wishlist-count]').forEach(function (el) {
      var count = String(list.length);
      if (el.textContent !== count) el.textContent = count;
      if (el.hidden !== (list.length === 0)) el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-rv-heart]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute('data-rv-heart');
    var list = read();
    var at = list.indexOf(handle);
    if (at > -1) list.splice(at, 1);
    else list.unshift(handle);
    write(list);
    paint();
    document.dispatchEvent(new CustomEvent('rv:wishlist-changed'));
  });

  function money(cents) {
    return (cents / 100).toLocaleString('he-IL', { maximumFractionDigits: 2 }) + ' ₪';
  }

  function renderPage() {
    var root = document.querySelector('[data-rv-wishlist-page]');
    if (!root) return;
    var grid = root.querySelector('[data-rv-wishlist-grid]');
    var empty = root.querySelector('[data-rv-wishlist-empty]');
    var list = read();
    empty.hidden = list.length > 0;
    grid.innerHTML = '';
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(
      list.map(function (handle) {
        return fetch(base + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      products.forEach(function (p) {
        if (!p) return;
        var li = document.createElement('li');
        li.className = 'rv-wish-card';
        var link = document.createElement('a');
        link.href = p.url;
        link.className = 'rv-wish-card__media';
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=533';
          img.alt = p.title;
          img.loading = 'lazy';
          link.appendChild(img);
        }
        var title = document.createElement('a');
        title.href = p.url;
        title.className = 'rv-wish-card__title';
        title.textContent = p.title;
        var price = document.createElement('div');
        price.className = 'rv-wish-card__price';
        price.textContent = p.available ? money(p.price) : 'אזל המלאי';
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'rv-wish-card__remove link underlined-link';
        remove.setAttribute('data-rv-heart', p.handle);
        remove.textContent = 'הסרה מהרשימה';
        li.appendChild(link);
        li.appendChild(title);
        li.appendChild(price);
        li.appendChild(remove);
        grid.appendChild(li);
      });
    });
  }

  document.addEventListener('rv:wishlist-changed', renderPage);
  document.addEventListener('DOMContentLoaded', function () {
    paint();
    renderPage();
    // Repaint only when new heart buttons are added to the page (filtering, quick view), once per frame
    var queued = false;
    new MutationObserver(function (mutations) {
      var found = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('[data-rv-heart]') || node.querySelector('[data-rv-heart]'));
        });
      });
      if (!found || queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; paint(); });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
